<template>
	<transition name="fade" appear>
		<div class="v-resume-modal" v-if="isModalOpen" @click.self="closeModal">
			<div class="v-resume-modal__body">
				<slot name="modal_content"/>
				<button class="v-resume-modal__close" @click="closeModal">
					<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
						<rect y="1.09082" width="1.54276" height="15.4276" rx="0.771381" transform="rotate(-45 0 1.09082)" fill="#9FAAB6"/>
						<rect x="10.9102" width="1.54276" height="15.4276" rx="0.771381" transform="rotate(45 10.9102 0)" fill="#9FAAB6"/>
					</svg>
				</button>
			</div>
		</div>
	</transition>
</template>
<script>
import VResumeIconButton from '@/components_new/b2c/vresume-icon-button/index'
export default {
	components: {
		VResumeIconButton
	},
	props: {
		isModalOpen: Boolean
	},
	methods: {
		closeModal() {
			this.$emit('closeModal')
		}
	}
}
</script>
<style lang="scss" scoped>
.v-resume-modal {
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	display: flex;
	align-items: center;
	justify-content: center;
	background: linear-gradient(284.04deg, rgba(22, 37, 172, 0.33) 0%, rgba(173, 108, 224, 0.5) 100%);
	z-index: 999999;

	&__body {
		padding: 20px;
		background: #FFFFFF;
		box-shadow: 0px 0px 25px rgba(35, 51, 70, 0.1);
		border-radius: 4px;
		position: relative;
		z-index: 999999;
		width: 360px;
		opacity: 1;
		box-sizing: border-box;
	}

	&__close {
		position: absolute;
		top: 20px;
		right: 20px;

		& svg {
			width: 12px;
			height: 12px;
		}
	}
}

.fade {
	&-enter-active {
		transition: all .2s ease;
	}

	&-leave-active {
		transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
	}

	&-enter {
		opacity: 0;
	}

	&-leave-to {
		transform: translateY(20px);
  	opacity: 0;
	}
}
</style>